// Lib
import React from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MouseTransition, MultiBackend, MultiBackendOptions, TouchTransition } from 'react-dnd-multi-backend';
import { DndProvider } from 'react-dnd';

// Device
import platformSingleton from '../../platform/platformSingleton';

// Customised touch backend
import TouchBackend from '../../../node_module_clones/touch-backend/src';

// Types
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

const Html5toTouch: MultiBackendOptions = {
    backends: [
        {
            id: 'html5',
            backend: HTML5Backend,
            transition: MouseTransition,
        },
        {
            id: 'touch',
            backend: TouchBackend,
            options: {
                enableMouseEvents: true,
                ignoreContextMenu: platformSingleton.appMode !== MilanoteApplicationMode.desktop,
            },
            preview: true,
            transition: TouchTransition,
        },
    ],
};

const WorkspaceDndProvider = (props: { children: React.ReactNode }) => (
    <DndProvider backend={MultiBackend} options={Html5toTouch}>
        {props.children}
    </DndProvider>
);

export default WorkspaceDndProvider;
